/**
 * @file Especialização CNPJ do pipeline Input.
 * @module components/create/cnpj
 */

/**
 * Configura um input textual com máscara e validação de CNPJ.
 *
 * Defaults: `dic.labels.cnpj` como label e ícone `money-check` como prefixo. A
 * validação roda no blur e no keyup quando o campo está vazio ou completo com
 * 18 caracteres mascarados.
 *
 * @param {HTMLInputElement} elem Input base.
 * @param {Object} options Opções recebidas pelo componente.
 * @param {Function} [options.callback] Callback repassado ao validador `checkCNPJ`.
 * @returns {Array.<HTMLInputElement|Object>} Input e `options` normalizado.
 */
export default (elem, options) => {
  options.type = 'text';
  options.mask = { template: 'cnpj' };

  if(options.label === undefined){
    options.label = dic.labels.cnpj;
  }

  if(options.prefix === undefined){
    options.prefix = { icon: { name: 'money-check', type: 'solid' } };
  }

  if (options.callback !== undefined && typeof options.callback === 'function') {
    elem.callback = options.callback;
  }

  document.addEventListener('DOMContentLoaded', () => {
    const size = [0, 18];
    if (size.indexOf(elem.value.length) >= 0) {
      elem.checkCNPJ(elem.callback);
    }
  });

  elem.addEventListener('keyup', (e) => {
    const size = [0, 18];
    if (size.indexOf(e.target.value.length) >= 0) {
      e.target.checkCNPJ(e.target.callback);
    }
  });

  elem.addEventListener('blur', (e) => {
    e.target.checkCNPJ(e.target.callback);
  });

  return [elem, options];
}